import React from 'react';
import { ExternalLink, Newspaper, Play, Video } from 'lucide-react';
import { rassegnaStampa } from './reviewsData';

const PressLinkCard = ({ item, index }) => (
  <a
    href={item.url}
    target="_blank"
    rel="noopener noreferrer"
    className="review-card bg-bg-card p-6 rounded-lg border border-border-medium hover:border-brand-primary transition-all duration-300 group"
    data-testid={`press-link-${index}`}
  >
    <div className="flex items-start gap-4">
      <div className="w-12 h-12 rounded-full bg-secondary-olive flex items-center justify-center flex-shrink-0 group-hover:bg-brand-primary transition-colors">
        {item.icon === 'youtube' ? (
          <Play className="w-6 h-6 text-brand-primary group-hover:text-text-inverse" />
        ) : (
          <Newspaper className="w-6 h-6 text-brand-primary group-hover:text-text-inverse" />
        )}
      </div>
      <div className="flex-1">
        <div className="flex items-center gap-2 mb-2">
          <span className="inline-block px-3 py-1 bg-brand-primary text-text-inverse text-xs font-semibold rounded-full">
            {item.testata}
          </span>
          <span className="text-xs text-text-secondary">{item.tipo}</span>
        </div>
        <h3 className="body-medium text-text-primary group-hover:text-brand-primary transition-colors line-clamp-2">
          {item.titolo}
        </h3>
        <div className="flex items-center gap-1 mt-3 text-brand-primary text-sm">
          <span>Leggi</span>
          <ExternalLink className="w-4 h-4" />
        </div>
      </div>
    </div>
  </a>
);

const TeledehonVideoCard = () => (
  <div
    className="review-card bg-bg-card rounded-lg border-2 border-brand-primary overflow-hidden mb-10"
    data-testid="rassegna-teledehon-video"
  >
    <div className="p-6 border-b border-border-medium flex items-center gap-3">
      <div className="w-12 h-12 rounded-full bg-brand-primary flex items-center justify-center flex-shrink-0">
        <Video className="w-6 h-6 text-text-inverse" />
      </div>
      <div>
        <span className="inline-block px-3 py-1 bg-brand-primary text-text-inverse text-xs font-semibold rounded-full mb-1">
          Teledehon
        </span>
        <h3 className="body-medium text-text-primary">
          Intervista sul libro Cronache dal fronte invisibile
        </h3>
      </div>
    </div>
    <div className="bg-black">
      <video
        controls
        preload="none"
        poster="/book-cover.jpg"
        className="w-full h-auto max-h-[600px] mx-auto"
        data-testid="rassegna-teledehon-video-player"
      >
        <source src="/teledehon-video.mp4" type="video/mp4" />
        Il tuo browser non supporta la riproduzione video.
      </video>
    </div>
  </div>
);

export const RassegnaStampaTab = () => (
  <div className="max-w-4xl mx-auto">
    <TeledehonVideoCard />
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {rassegnaStampa.map((item, index) => (
        <PressLinkCard key={item.url} item={item} index={index} />
      ))}
    </div>
    <p className="text-center text-text-secondary mt-8 text-sm">
      Clicca su ogni card per aprire l'articolo o il video
    </p>
  </div>
);

